import type { AbstractIntlMessages } from "next-intl";

export function transformMessagesToKeys(
  messages: AbstractIntlMessages,
  parentPath: string = ""
): AbstractIntlMessages {
  const result: Record<string, unknown> = {};

  for (const [key, value] of Object.entries(messages)) {
    const fullPath = parentPath ? `${parentPath}.${key}` : key;

    if (typeof value === "object" && value !== null && !Array.isArray(value)) {
      result[key] = transformMessagesToKeys(value as AbstractIntlMessages, fullPath);
    } else {
      result[key] = fullPath;
    }
  }

  return result as AbstractIntlMessages;
}
